import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { NgClass, NgIf, NgOptimizedImage } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [NgOptimizedImage, FormsModule, NgClass, NgIf],
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit, OnDestroy {
  @Input() variant: 'outline' | 'second' = 'outline';
  @Input() maxWidth: string = '100%';
  @Output() onSearch = new EventEmitter<string>();
  @Input() textValue: string = '';
  @Input() placeholder: string = '';
  errorMessage: string = '';
  private destroy$ = new Subject<void>();
  private hasInteracted = false;

  ngOnInit() {}

  onInputChange(value: string) {
    this.textValue = value.trim();

    if (this.textValue.length >= 3) {
      this.errorMessage = '';
      this.onSearch.emit(this.textValue);
    } else if (this.hasInteracted) {
      this.errorMessage = 'Будь ласка, введіть щонайменше 3 символи';
    }

    if (this.textValue.length === 0) {
      this.onSearch.emit('');
      return;
    }
  }

  onSearchIconClick() {
    this.hasInteracted = true;
    if (this.textValue.length >= 3) {
      this.errorMessage = '';
      this.onSearch.emit(this.textValue);
    } else {
      if (this.hasInteracted) {
        this.errorMessage = 'Будь ласка, введіть щонайменше 3 символи';
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
